import ExchangeConnect from '../../components/exchange/ExchangeConnect';
import ExchangeConversion from '../../components/exchange/ExchangeConversion';
import ExchangeRate from '../../components/exchange/ExchangeRate';
import { Contain } from '../../components/Grid';
import Image from '../../components/Image';
import { MerchantDetails, TermsAndConditions } from '../../components/MerchantDetails';
import { PartnerLayout } from '../../components/PartnerDetails/styles';
import SeoHead from '../../components/SeoHead';
import { linkpassGet } from '../../utils/fetch';
import { toPartnerData } from '../../utils/linkpassAdapters';
import withErrorHandling from '../../utils/withErrorHandling';
import ErrorPage from '../_error';

const ExchangeDetail = ({ partnerData, user = {}, error }) => {
  if (error) {
    return <ErrorPage error={error} />;
  }

  const { metaTitle, metaDescription, merchantName, merchantLogoUrl, bannerUrl, description, tnc } =
    partnerData;

  return (
    <Contain>
      <SeoHead
        title={metaTitle || merchantName}
        description={metaDescription || merchantName}
        image={bannerUrl}
      />
      <PartnerLayout>
        <MerchantDetails
          merchantName={merchantName}
          description={description}
          bannerUrl={bannerUrl}
          merchantLogoUrl={merchantLogoUrl}
        />
        <div className="merchant-detail">
          <div className="merchant-detail-main">
            <div className="exchangepage-banner">
              <Image
                fill
                alt="banner image"
                src={bannerUrl}
                sizes="(max-width: 1200px) 50vw,33vw"
              />
            </div>
          </div>
          <div className="exchange-section">
            {user.loggedInMerchant ? (
              <ExchangeConversion partnerData={partnerData} user={user} />
            ) : (
              <>
                <ExchangeRate rates={partnerData.rates} />
                <ExchangeConnect partnerData={partnerData} user={user} />
              </>
            )}
          </div>
          {tnc && <TermsAndConditions tnc={tnc} />}
        </div>
      </PartnerLayout>
    </Contain>
  );
};

export const getData = async (ctx) => {
  const { permalink } = ctx.params;
  const exchangeId = permalink.split('-')[0];

  /*
   * Linkpass: one call replaces three. GET /pex/me/exchanges/:id returns the partner, its
   * rates and a user block, so /v1/pointExchange/description and /v1/exchangeToken/validate
   * both collapse into it - user.loggedInPartner is what validate existed to answer.
   *
   */
  const partnerData = toPartnerData(
    await linkpassGet(`/pex/me/exchanges/${exchangeId}`, ctx),
    permalink,
  );

  return {
    props: {
      partnerData,
      ...(partnerData.loggedInPlus && {
        user: {
          loggedInPlus: partnerData.loggedInPlus,
          loggedInMerchant: partnerData.loggedInMerchant,
          // rendered as "Member ID"; the old page passed the accesstoken cookie
          accesstoken: partnerData.vc ?? null,
          // the member's id on the partner side, previously from validate
          memberId: partnerData.externalId ?? null,
        },
      }),
    },
  };
};

export const getServerSideProps = withErrorHandling(getData);

export default ExchangeDetail;
